import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{attrs:{"hide-overlay":"","width":"auto","content-class":"custom-alert-dialog"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(VAlert,{attrs:{"dense":"","type":_vm.config.type},on:{"click":function($event){return _vm.$refs.alert_pop_up.showPopUp()}}},[_vm._v(" "+_vm._s(_vm.config.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }